<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center my-5">Resultados de Evaluacion</h2>
  <div class="flex justify-between items-center mb-4">
    <button class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded" (click)="volver()" >Volver</button>
    <button class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded" (click)="goToCreateResultados()">Registrar Resultados</button>
    <!-- <button class="bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 rounded" (click)="goToCreateResultados()">Subir Resultados por Excel</button> -->
  </div>
  <app-table
    [data]="resultadosEvaluacion"
    [columns]="columns"
    [actions]="actions"
    searchPlaceholder="Buscar evaluaciones..."
  ></app-table>
</div>
